import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'lightbox-react';
import place_holder from '../../assets/img/image_failed_place_holder';
import 'lightbox-react/style.css';
import Translate from '../common/Translate';
import { formManager } from '../../config/configuration/react';

const ReportImage = ({ index, imageId, name, hideLabel, allImages, getImage = true }) => {
  const [image, setImage] = useState(place_holder);
  const [popedUp, setPopup] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  useEffect(() => {
    try {
      if (imageId === undefined || imageId === null || !getImage) return;
      if (allImages.length > 0 && allImages[index].src) setImage(allImages[index].src);
      else formManager.getImage(imageId).then((img) => setImage(img));
    } catch (e) {
      setImage(place_holder);
    }
  }, [imageId, getImage]);

  const togglePopup = () => {
    setPhotoIndex(index);
    setPopup(!popedUp);
  };

  return (
    <div className="report-gallery-desktop">
      {popedUp && (
        <Lightbox
          mainSrc={(allImages.length > 0 && allImages[photoIndex]?.src) || image}
          nextSrc={allImages[(photoIndex + 1) % allImages.length]?.src}
          prevSrc={allImages[(photoIndex + allImages.length - 1) % allImages.length]?.src}
          onCloseRequest={togglePopup}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + allImages.length - 1) % allImages.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % allImages.length)}
        />
      )}

      <span onClick={() => togglePopup()} onKeyDown={() => {}} role="presentation">
        <img className="report-image" src={image} alt="" />
      </span>

      {!hideLabel && (
        <p className="report-element-label">
          <font color="#273c78">
            <Translate code={name} />
          </font>
        </p>
      )}
    </div>
  );
};

export default ReportImage;

ReportImage.propTypes = {
  index: PropTypes.number,
  imageId: PropTypes.number.isRequired,
  name: PropTypes.string,
  hideLabel: PropTypes.bool,
  allImages: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  getImage: PropTypes.bool,
};

ReportImage.defaultProps = {
  index: undefined,
  name: '',
  hideLabel: undefined,
  allImages: [],
  getImage: undefined,
};
